import { render, staticRenderFns } from "./SiteHeaderSummaryComponent.vue?vue&type=template&id=5682e79a&scoped=true"
import script from "./SiteHeaderSummaryComponent.vue?vue&type=script&lang=js"
export * from "./SiteHeaderSummaryComponent.vue?vue&type=script&lang=js"
import style0 from "./SiteHeaderSummaryComponent.vue?vue&type=style&index=0&id=5682e79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682e79a",
  null
  
)

export default component.exports